import React, { useState } from 'react';
import { Flex, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ChevronRightIcon } from '@/assets/icons/icons';
import PublishReportModal from './PublishReportModal';
import ExportReportModal from './ExportReportModal';
import { useSelector } from 'react-redux';

type ReportDispositionAction = 'publish' | 'reject';

const DISPOSITION_ACTIONS: Array<{
  action: ReportDispositionAction;
  label: string;
}> = [
  { action: 'publish', label: 'Review & publish' },
  { action: 'reject', label: 'Reject' },
];

interface GxpReportHeaderProps {
  reportID?: string;
  refID?: string;
  canPublish?: boolean;
  exportNoticeText?: string;
  handleRefreshPageData?: () => void;
}

const GxpReportHeader: React.FC<GxpReportHeaderProps> = ({
  reportID,
  refID,
  canPublish,
  exportNoticeText,
  handleRefreshPageData,
}) => {
  const navigate = useNavigate();
  const [isExportOpen, setIsExportOpen] = useState(false);
  const [isPublishOpen, setIsPublishOpen] = useState(false);
  const [dispositionAction, setDispositionAction] =
    useState<ReportDispositionAction>('publish');

  const features = useSelector(
    (state: {
      menu: {
        features: Array<{ name: string; permissions?: { is_view?: boolean } }>;
      };
    }) => state.menu.features
  );
  const publish_gxp_report_permissons = features?.find(
    (feature) => feature?.name === 'Publish GxP report'
  );

  return (
    <>
      <Flex
        className='gxp-header-wrapper'
        align='center'
        justify='space-between'
      >
        <Flex
          gap={8}
          align='center'
          className='cursor-pointer back-arrow-style'
          onClick={() => navigate(-1)}
        >
          <ChevronRightIcon
            fill='var(--text-primary)'
            width={16}
            height={16}
            className='rotate-180'
          />
          <Typography.Text
            className='gxp-header-ref-id'
            ellipsis={{ tooltip: refID }}
          >
            {refID}
          </Typography.Text>
        </Flex>

        <Flex gap={8} align='center'>
          <button
            type='button'
            className='gxp-header-btn gxp-header-btn--secondary'
            onClick={() => setIsExportOpen(true)}
          >
            Export
          </button>

          {publish_gxp_report_permissons?.permissions?.is_view && (
            <>
              {DISPOSITION_ACTIONS.map(({ action, label }) => (
                <button
                  key={action}
                  type='button'
                  className={`gxp-header-btn ${canPublish ? 'gxp-header-btn--primary' : 'gxp-header-btn--disabled'}`}
                  disabled={!canPublish}
                  onClick={() => {
                    setDispositionAction(action);
                    setIsPublishOpen(true);
                  }}
                >
                  {label}
                </button>
              ))}
            </>
          )}
        </Flex>
      </Flex>

      {isPublishOpen && (
        <PublishReportModal
          reportID={reportID}
          open={isPublishOpen}
          action={dispositionAction}
          referenceID={refID}
          onCancel={() => setIsPublishOpen(false)}
          handleRefreshPageData={handleRefreshPageData}
        />
      )}
      {isExportOpen && (
        <ExportReportModal
          reportID={reportID}
          open={isExportOpen}
          referenceID={refID}
          noticeText={exportNoticeText}
          onCancel={() => setIsExportOpen(false)}
        />
      )}
    </>
  );
};

export default GxpReportHeader;
